// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gA8q","footer":"styles_footer__2wB55"};